import { render, staticRenderFns } from "./InsurerAddress.vue?vue&type=template&id=535200c1"
import script from "./InsurerAddress.vue?vue&type=script&lang=js"
export * from "./InsurerAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports